import React from 'react';
import { componentService } from 'js/services/component.service';

export const Banner = React.lazy(() => import(/* webpackChunkName: "banner" */ './Banner'));

componentService.registerPageComponents({ banner: Banner });
componentService.registerWebContentComponents({ Banner });
